<template>
  <v-app id="app">
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: "App",

  metaInfo() {
    return {
      title: this.$i18n.t("meta.app.title")
    }
  },

  components: {},

  data: () => ({
    //
  })
}
</script>

<style lang="scss">
@import "@/sass/main.scss";
body {
  .v-application {
    font-family: "Open-sans", sans-serif;
    .v-toolbar__title {
      font-family: "Aleo";
    }
    h1.display-1, h1.headline {
      font-family: "Aleo" !important;
    }
  }
}

.aleo {
  font-family: "Aleo", "Times New Roman", serif !important;
}
#app {
  .theme--light.v-application {
    color: black;
  }
  .theme--light.v-sheet {
    color: black;
  }
  .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
    color: black !important;
  }
  .v-input--radio-group__input .theme--light.v-label,
  .v-input--checkbox .theme--light.v-label {
    color: black;
  }
  .v-input--radio-group__input {
    width: auto;
  }
}
</style>
